import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import StudentsList from '../components/student/StudentsList';
import Spinner from '../components/common/Spinner';
import StudentSearch from '../components/student/StudentSearch';
import StudentsReportModal from '../components/report/StudentsReportModal';
import { getStudents } from '../actions/studentActions';
import { STUDENTS_ROWS } from '../constants/constants';
import { isAdministrator } from '../utils/helpers';
import '../styles/students-list.scss';

class StudentsPage extends Component {
  constructor() {
    super();

    this.state = { showReportModal: false };

    this.onClickViewMore = this.onClickViewMore.bind(this);
  }

  componentWillMount() {
    const { getStudents } = this.props;
    const emptyFilters = {
      name: '',
      cycle: '',
      gradeInstance: ''
    };
    getStudents(emptyFilters, STUDENTS_ROWS);
  }

  onClickViewMore() {
    const { getStudents, currentPage, filters } = this.props;
    const nextPage = currentPage + 1;
    getStudents(filters, STUDENTS_ROWS, nextPage);
  }

  render() {
    const {
      students,
      currentPage,
      totalPages,
      loading,
      loadingMore,
      user
    } = this.props;
    const { showReportModal } = this.state;
    const morePages = totalPages > currentPage;

    return (
      <div id="students-list">
        <div className="students-header">
          <h4>LISTADO ALUMNOS</h4>
          {isAdministrator(user) &&
            <div className="modal-link">
              <div onClick={() => this.setState({ showReportModal: true })}>
                + <u>Nuevo reporte</u>
              </div>
              <StudentsReportModal
                show={showReportModal}
                onClose={() => this.setState({ showReportModal: false })}
              />
            </div>
          }
          {isAdministrator(user) &&
            <Link to="/nuevo-alumno">+ <u>Nuevo alumno</u></Link>
          }
        </div>
        <StudentSearch />
        {loading && <Spinner />}
        {!loading &&
          <div>
            <StudentsList students={students} />
            {loadingMore && <Spinner />}
            {!loadingMore && morePages &&
              <button className="view-more" onClick={this.onClickViewMore}>
                Ver Más
              </button>
            }
          </div>
        }
      </div>
    );
  }
}

const { object, array, number, bool, func } = PropTypes;

StudentsPage.propTypes = {
  getStudents: func.isRequired,
  students: array.isRequired,
  currentPage: number.isRequired,
  totalPages: number.isRequired,
  loading: bool.isRequired,
  loadingMore: bool.isRequired,
  filters: object.isRequired,
  user: object.isRequired
};

const mapState = state => ({
  students: state.getIn(['student', 'students']).toJS(),
  currentPage: state.getIn(['student', 'currentPage']),
  totalPages: state.getIn(['student', 'totalPages']),
  loading: state.getIn(['student', 'loading']),
  loadingMore: state.getIn(['student', 'loadingMore']),
  filters: state.getIn(['student', 'filters']).toJS(),
  user: state.getIn(['session', 'user']).toJS(),
});

const mapDispatch = dispatch => ({
  getStudents: (filters, rows, nextPage) => dispatch(getStudents(filters, rows, nextPage))
});

export default connect(mapState, mapDispatch)(StudentsPage);



// WEBPACK FOOTER //
// ./src/containers/StudentsPage.js